import { fmtL, fmtNum } from '../../utils/format';

function CERow({ r }) {
  return (
    <tr className={r.atm ? 'ar' : ''}>
      <td className={`ib ${r.interpretClass}`}>{r.interpret}</td>
      <td>{fmtL(r.vol)}</td>
      <td className={r.volChg != null && r.volChg >= 0 ? 'pos' : 'neg'}>{r.volChg != null ? fmtL(r.volChg) : '-'}</td>
      <td className={r.oiChg >= 0 ? 'pos' : 'neg'}>{fmtL(r.oiChg)}</td>
      <td>{fmtL(r.netOi)}</td>
      <td className={r.prcChg >= 0 ? 'pos' : 'neg'}>{fmtNum(r.prcChg)}</td>
      <td className="lt">{fmtNum(r.ltp)}</td>
      <td className={r.hv ? 'hv' : ''}>{fmtNum(r.volStr)}</td>
      <td className={r.ho ? 'ho' : ''}>{fmtNum(r.oiStr)}</td>
      <td className="sk">{fmtNum(r.strike, 0)}</td>
    </tr>
  );
}

function PERow({ r }) {
  return (
    <tr className={r.atm ? 'ar' : ''}>
      <td className="sk">{fmtNum(r.strike, 0)}</td>
      <td className={r.ho ? 'ho' : ''}>{fmtNum(r.oiStr)}</td>
      <td className={r.hv ? 'hv' : ''}>{fmtNum(r.volStr)}</td>
      <td className="lt">{fmtNum(r.ltp)}</td>
      <td className={r.prcChg >= 0 ? 'pos' : 'neg'}>{fmtNum(r.prcChg)}</td>
      <td>{fmtL(r.netOi)}</td>
      <td className={r.oiChg >= 0 ? 'pos' : 'neg'}>{fmtL(r.oiChg)}</td>
      <td className={r.volChg != null && r.volChg >= 0 ? 'pos' : 'neg'}>{r.volChg != null ? fmtL(r.volChg) : '-'}</td>
      <td>{fmtL(r.vol)}</td>
      <td className={`ib ${r.interpretClass}`}>{r.interpret}</td>
    </tr>
  );
}

export default function OCTables({ ceRows, peRows }) {
  return (
    <div className="oc-tw" id="ocTables">
      <div className="oc-ts">
        <table className="ot">
          <thead>
            <tr><th colSpan={10} className="ch-hdr">CALL (TOP 6 BY OI)</th></tr>
            <tr>
              <th>INTERPRET</th><th>VOL</th><th>VOL CHG</th><th>OI CHG</th><th>NET OI</th>
              <th>PRC CHG</th><th>LTP</th><th>VOL STR</th><th>OI STR</th><th>STRIKE</th>
            </tr>
          </thead>
          <tbody>
            {ceRows.map((r, i) => <CERow key={`ce-${i}`} r={r} />)}
          </tbody>
        </table>
        <table className="ot">
          <thead>
            <tr><th colSpan={10} className="ph-hdr">PUT (TOP 6 BY OI)</th></tr>
            <tr>
              <th>STRIKE</th><th>OI STR</th><th>VOL STR</th><th>LTP</th><th>PRC CHG</th>
              <th>NET OI</th><th>OI CHG</th><th>VOL CHG</th><th>VOL</th><th>INTERPRET</th>
            </tr>
          </thead>
          <tbody>
            {peRows.map((r, i) => <PERow key={`pe-${i}`} r={r} />)}
          </tbody>
        </table>
      </div>
    </div>
  );
}